import { create } from 'zustand'

export type NotificationType =
  | 'conversation'
  | 'assignment'
  | 'ai'
  | 'system'
  | 'widget'

export interface RealtimeNotification {
  id: string
  type: NotificationType
  title: string
  message: string
  createdAt: string
  read: boolean
  metadata?: Record<string, unknown>
}

interface NotificationState {
  notifications: RealtimeNotification[]
  unreadCount: number
  addNotification: (notification: RealtimeNotification) => void
  markAsRead: (id: string) => void
  markAllAsRead: () => void
  clear: () => void
}

export const useNotificationsStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  addNotification: (notification) =>
    set((state) => ({
      notifications: [notification, ...state.notifications].slice(0, 50),
      unreadCount: state.unreadCount + 1,
    })),
  markAsRead: (id) =>
    set((state) => ({
      notifications: state.notifications.map((notification) =>
        notification.id === id ? { ...notification, read: true } : notification,
      ),
      unreadCount: Math.max(
        0,
        state.unreadCount - (state.notifications.find((notification) => notification.id === id && !notification.read) ? 1 : 0),
      ),
    })),
  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((notification) => ({ ...notification, read: true })),
      unreadCount: 0,
    })),
  clear: () =>
    set(() => ({
      notifications: [],
      unreadCount: 0,
    })),
}))
